import * as React from 'react';

import _t from 'i18n!nls/enterprise-legacy-learner-home';

type SvgObjectivesStep1Props = React.SVGProps<SVGSVGElement>;

const SvgObjectivesStep1 = (props: SvgObjectivesStep1Props) => (
  <svg height={132} viewBox="0 0 313 132" width={313} role="presentation" {...props}>
    <title id="SvgObjectivesStep1-Title">{_t('Find an objective')}</title>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h313v132H0z" fill="var(--cds-color-grey-25)" />
      <g opacity={0.4} transform="translate(107 9)">
        <rect
          fill="var(--cds-color-neutral-primary-invert)"
          height={28.321}
          rx={2}
          stroke="var(--cds-color-grey-25)"
          width={110}
          x={0.5}
          y={0.5}
        />
        <path d="M2 0h55.594v29.32H2a2 2 0 01-2-2V2a2 2 0 012-2z" fill="var(--cds-color-blue-600)" />
        <path d="M6.283 6.283h36.651v4.189H6.283z" fill="var(--cds-color-neutral-primary-invert)" />
        <g fill="var(--cds-color-grey-600)">
          <path d="M67.019 7.33h15.707v3.142H67.02zM67.019 13.613h19.896v3.142H67.02zM67.019 19.896h13.613v3.142H67.02z" />
        </g>
        <path d="M6.283 14.66h26.18v4.19H6.282z" fill="var(--cds-color-neutral-primary-invert)" />
      </g>
      <g transform="translate(107 50.887)">
        <rect
          fill="var(--cds-color-neutral-primary-invert)"
          height={28.321}
          rx={2}
          stroke="var(--cds-color-grey-25)"
          width={110}
          x={0.5}
          y={0.5}
        />
        <path d="M2 0h55.594v29.32H2a2 2 0 01-2-2V2a2 2 0 012-2z" fill="var(--cds-color-blue-600)" />
        <path d="M6.283 6.283h36.651v4.189H6.283z" fill="var(--cds-color-neutral-primary-invert)" />
        <g fill="var(--cds-color-grey-600)">
          <path d="M67.019 7.33h15.707v3.142H67.02zM67.019 13.613h19.896v3.142H67.02zM67.019 19.896h13.613v3.142H67.02z" />
        </g>
        <path d="M6.283 14.66h26.18v4.19H6.282z" fill="var(--cds-color-neutral-primary-invert)" />
      </g>
      <g opacity={0.4} transform="translate(107 92.774)">
        <rect
          fill="var(--cds-color-neutral-primary-invert)"
          height={28.321}
          rx={2}
          stroke="var(--cds-color-grey-25)"
          width={110}
          x={0.5}
          y={0.5}
        />
        <path d="M2 0h55.594v29.32H2a2 2 0 01-2-2V2a2 2 0 012-2z" fill="var(--cds-color-blue-600)" />
        <path d="M6.283 6.283h36.651v4.189H6.283z" fill="var(--cds-color-neutral-primary-invert)" />
        <g fill="var(--cds-color-grey-600)">
          <path d="M67.019 7.33h15.707v3.142H67.02zM67.019 13.613h19.896v3.142H67.02zM67.019 19.896h13.613v3.142H67.02z" />
        </g>
        <path d="M6.283 14.66h26.18v4.19H6.282z" fill="var(--cds-color-neutral-primary-invert)" />
      </g>
    </g>
  </svg>
);

export default SvgObjectivesStep1;
